import store from "../index.js";
import axios from "axios";
const host = process.env.VUE_APP_COLD_HOST;

export const modules = {
  store,
};

export const state = {};

export const mutations = {};

//이것만 예외로 api로 보냄
//키도 임시로
export const actions = {
  async acCold() {
    const url = `${host}/api/v1/cold`;
    try {
      await axios.post(
        url,
        { kre_sec: "5tkslqwiwvmalq208" },
        {
          headers: {
            Authorization: `Bearer ${localStorage.ad_to_ac_se}`,
          },
        }
      );
    } catch (err) {
      console.log("err", err.message);
      return false;
    }
  },
  async acColdForce({ commit }, { user_no, email, order_seq }) {
    const url = `${host}/api/v1/cold/force`;
    try {
      await axios.post(
        url,
        {
          kre_sec: "5tkslqwiwvmalq208",
          payload: {
            userNo: user_no,
            email: email,
            orderSeq: order_seq,
          },
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.ad_to_ac_se}`,
          },
        }
      );
    } catch (err) {
      console.log("err", err.message);
      return false;
    }
  },
  async acColdBuildingAndPrice() {
    const url = `${host}/api/v1/cold/building-and-price`;
    try {
      await axios.post(
        url,
        { kre_sec: "5tkslqwiwvmalq208" },
        {
          headers: {
            Authorization: `Bearer ${localStorage.ad_to_ac_se}`,
          },
        }
      );
    } catch (err) {
      console.log("err", err.message);
      return false;
    }
  },
  async acColdFirstDepositBulk() {
    const url = `${host}/api/v1/cold/first-deposit`;
    try {
      await axios.post(
        url,
        { kre_sec: "5tkslqwiwvmalq208" },
        {
          headers: {
            Authorization: `Bearer ${localStorage.ad_to_ac_se}`,
          },
        }
      );
    } catch (err) {
      console.log("err", err.message);
      return false;
    }
  },
  async acCorpCreditDirectInput(_, payload) {
    const url = `${host}/api/v1/cold/corp-credit-direct-input`;
    try {
      await axios.post(
        url,
        { kre_sec: "5tkslqwiwvmalq208", ...payload },
        {
          headers: {
            Authorization: `Bearer ${localStorage.ad_to_ac_se}`,
          },
        }
      );
    } catch (err) {
      console.log("err", err.message);
      return false;
    }
  },
};

export const getters = {};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
